import { useEffect, useRef, useState } from "react";
import AnthonyLogo from "../../../../resources/icons/portfolio/anthony_icon.svg";
import BiomaskLogo from "../../../../resources/icons/portfolio/biomask_icon.svg";
import HWLLogo from "../../../../resources/icons/portfolio/hwl_icon.svg";
import IlhaPneuLogo from "../../../../resources/icons/portfolio/ilhapneu_icon.png";
import NMDSLogo from "../../../../resources/icons/portfolio/nmds_icon.png";
import BioReboot from "../../../../resources/icons/portfolio/bioreboot-logo.png";
import PneuzarcoLogo from "../../../../resources/icons/portfolio/pneuzarco_icon.svg";
import PoderLogo from "../../../../resources/icons/portfolio/poder_icon.png";
import SeehealthLogo from "../../../../resources/icons/portfolio/seehealth_icon.png";
import VCapital from "../../../../resources/icons/portfolio/vcapital-icon.svg";
import Vipa from "../../../../resources/icons/portfolio/vipa.pt-icon.svg";
import VipaenergyLogo from "../../../../resources/icons/portfolio/vipaenergy_icon.svg";
import VipainternationalLogo from "../../../../resources/icons/portfolio/vipainternational_icon.svg";
import VipaskyLogo from "../../../../resources/icons/portfolio/vipasky_icon.svg";
import VipatelecomLogo from "../../../../resources/icons/portfolio/vipatelecom_icon.png";
import VipaCorpLogo from "../../../../resources/icons/vipacorp.svg";
import AdGency from "../../../../resources/icons/portfolio/AdGency.svg";
import KRONOS from "../../../../resources/icons/portfolio/Kronos.png";
import CustomBrand from "./customBrand";
import CustomEvent from "./customEvent";
import { EventsLine, TimelineRow } from "./timelineStyles";

function CustomTimeline() {
  const [isDragging, setIsDragging] = useState(false);
  const timelineRef = useRef(null);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    startX.current = e.pageX - timelineRef.current.offsetLeft;
    scrollLeft.current = timelineRef.current.scrollLeft;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - timelineRef.current.offsetLeft;
    const walk = (x - startX.current) * 1;
    timelineRef.current.scrollLeft = scrollLeft.current - walk;
  };

  useEffect(() => {
    const timelineElement = timelineRef.current;

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const scrollInterval = setInterval(() => {
            scrollLeft.current += 1;
            timelineElement.scrollLeft = scrollLeft.current;
          }, 20);

          const stopScrolling = () => {
            clearInterval(scrollInterval);
          };

          observer.unobserve(timelineElement);
          timelineElement.addEventListener("mousedown", stopScrolling);

          return () => {
            clearInterval(scrollInterval);
            timelineElement.removeEventListener("mousedown", stopScrolling);
          };
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
    observer.observe(timelineElement);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <TimelineRow
      ref={timelineRef}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      <EventsLine />
      <CustomEvent
        year={"2009"}
        brands={
          <>
            <CustomBrand
              link={"https://www.grupovipa.pt/"}
              imgSrc={VipaCorpLogo}
              brandName={"Grupo Vipa"}
              brandSub={"Do Different."}
            />
            <CustomBrand
              link={"https://www.vcapital.pt"}
              imgSrc={VCapital}
              brandName={"VCapital"}
              brandSub={"Empowering the Future"}
            />
            <CustomBrand
              link={"https://www.ilhapneu.pt"}
              imgSrc={IlhaPneuLogo}
              brandName={"Ilha Pneu"}
              brandSub={"A Escolha Certa"}
            />
          </>
        }
      />
      <CustomEvent
        year={"2010"}
        reverseCol={true}
        centered={true}
        brands={
          <>
            <CustomBrand
              link={"https://www.vipainternational.com"}
              imgSrc={VipainternationalLogo}
              brandName={"Vipa International"}
              brandSub={"Moving you Forward"}
            />
          </>
        }
      />
      {/* Mantainance */}
      <CustomEvent
        year={"2014"}
        centered={true}
        brands={
          <>
            <CustomBrand
              link={"https://vipatelecom.pt/"}
              imgSrc={VipatelecomLogo}
              brandName={"Vipa Telecom"}
              brandSub={"Stay Connected"}
            />
          </>
        }
      />
      <CustomEvent
        year={"2015"}
        reverseCol={true}
        centered={true}
        brands={
          <>
            <CustomBrand
              link={"https://www.pneuzarco.pt"}
              imgSrc={PneuzarcoLogo}
              brandName={"Pneuzarco"}
              brandSub={"O Especialista do pneu"}
            />
          </>
        }
      />
      {/* maintenance */}
      <CustomEvent
        year={"2017"}
        centered={true}
        brands={
          <>
            <CustomBrand 
              imgSrc={AnthonyLogo} 
              brandName={"St Anthony"} />
          </>
        }
      />
      {/* maintenance */}
      <CustomEvent
        year={"2018"}
        centered={true}
        reverseCol={true}
        brands={
          <>
            <CustomBrand
              imgSrc={PoderLogo}
              brandName={"Poder & Negócios"}
            />
          </>
        }
      />
      <CustomEvent
        year={"2019"}
        brands={
          <>
            <CustomBrand 
              link={"https://vipa.pt"}
              imgSrc={Vipa}
              brandName={"Vipa.pt"}
              brandSub={"Laboratório de Software"}
            />
            <CustomBrand
              link={"https://www.hwl.pt"}
              imgSrc={HWLLogo}
              brandName={"Homes With Love"}
              brandSub={"Invista numa casa com amor"}
            />
          </>
        }
      />
      <CustomEvent
        year={"2020"}
        reverseCol={true}
        brands={
          <>
            <CustomBrand
              link={"https://www.seehealth.pt"}
              imgSrc={SeehealthLogo}
              brandName={"See Health"}
              brandSub={"A olhar pela sua saúde"}
            />
            {/* maintenance */}
            <CustomBrand
              imgSrc={VipaenergyLogo}
              text={"Ecologia, Renovaveis e Mar"}
              brandName={"Vipa Energia"}
              brandSub={"In motion for the future"}
            />
          </>
        }
      />
      <CustomEvent
        year={"2021"}
        brands={
          <>
            <CustomBrand
              //link={"https://www.nmds.pt"}
              imgSrc={NMDSLogo}
              brandName={"Números Distintos"}
              brandSub={"Gestão Financeira e Consultoria"}
            />
            <CustomBrand
              imgSrc={VipaskyLogo}
              brandName={"Vipa Sky"}
            />
            <CustomBrand
              link={"https://www.thebiomaskcompany.pt"}
              imgSrc={BiomaskLogo}
              brandName={"Biomask"}
            />
          </>
        }
      />
      <CustomEvent
        year={"2023"}
        centered={true}
        reverseCol={true}
        brands={
          <>
            <CustomBrand imgSrc={BioReboot} brandName={"BioReboot"} />
          </>
        }
      />
       <CustomEvent
  year={"2025"}
  brands={
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "5px" , color: "#fff",}}>
      <div style={{ fontWeight: 500, fontSize: "11px", marginBottom: "-25px" ,top: "-30px",position: "relative",}}>
        Saída de Capital
      </div>
      
      <div style={{ display: "flex", gap: "20px", opacity: 0.4,  }}>
        <CustomBrand
          imgSrc={NMDSLogo}
          brandName={"Números Distintos"}
          brandSub={"Gestão Financeira e Consultoria"}
        />
        <CustomBrand
          imgSrc={PoderLogo}
          brandName={"Poder & Negócios"}
        />
        <CustomBrand
          link={"https://vipainternational.com/"}
          imgSrc={VipainternationalLogo}
          brandName={"Vipa International"}
        />
      </div>

      
      

    </div>
  }
/>
       <div data-event style={{ flexShrink: 0 }}>
        <CustomEvent
        year={"2026"}
        reverseCol={true}
        brands={
          <>
            <CustomBrand imgSrc={AdGency} brandName={"AdGency"} />
            <CustomBrand imgSrc={KRONOS} brandName={"KRONOS"} />
          </>
        }
      />
      </div>
    </TimelineRow>
  );
}

export default CustomTimeline;
